import React, { createContext, PropsWithChildren, useContext, useMemo } from 'react';
import { useTheme } from '@razorpay/blade/components';
import { ColorSchemeNamesInput } from '@razorpay/blade/tokens';

type AppThemeContextType = {
  colorScheme: ColorSchemeNamesInput;
  setColorScheme: (colorScheme: ColorSchemeNamesInput) => void;
};

const AppThemeContext = createContext<AppThemeContextType | null>(null);

// Blade's TopNav wraps the header in its own dark BladeProvider, so useTheme() inside the
// header returns that nested theme. This bridge exposes the app-level theme so header
// controls (e.g. the theme switch) can change the whole app, not just the header.
export const AppThemeBridge = ({ children }: PropsWithChildren<{}>) => {
  const { colorScheme, setColorScheme } = useTheme();
  const value = useMemo(() => ({ colorScheme, setColorScheme }), [colorScheme, setColorScheme]);

  return <AppThemeContext.Provider value={value}>{children}</AppThemeContext.Provider>;
};

export const useAppTheme = () => useContext(AppThemeContext);
